// extracted by mini-css-extract-plugin
export default {"statistic":"TournamentStat_statistic__eyToA","show":"TournamentStat_show__W5+MQ","statheader":"TournamentStat_statheader__iTlkZ","listMatches":"TournamentStat_listMatches__wOZEB"};